import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import registerUser from '../../actions/registerUser';
import AuthHeader from './AuthHeader';

import SmileGoogleLogin from  './Socials/SmileGoogleLogin';
import SmileFacebookLogin from  './Socials/SmileFacebookLogin';

import {motion, AnimatePresence} from 'framer-motion';

import {authAnimation} from '../../animations';

import {strengthIndicator, strengthColor} from '../../helpers/passwordStrength';

import SaveOrLoad from './SaveOrLoad';

const Register = () => {

    const [username, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [registerText, setRegisterText] = useState('Get started');

    const [colour, setColour] = useState('');

    const {registerErrors, user} = useSelector((state) => state.user)

    const dispatch = useDispatch();

    /**
     * User has submitted the registration form.
     */
    const handleSubmit = (evt) => {
        evt.preventDefault();

        // Set button text to show we are doing something.
        setRegisterText( 'Loading...' );

        // Try to register the user via the api.
        dispatch(registerUser({username, email, password}));
    }

    /**
     * User is typing in the password field.
     */
    const passwordChange = (e) => {
        e.preventDefault();

        // Set the state.
        setPassword(e.target.value)

        // Check the strength.
        const newStrength = strengthIndicator( e.target.value );

        // Output a visual for the strength
        setColour( strengthColor( newStrength ) );
    }

    /**
     * Reset the button text when we get registration errors.
     */
    useEffect(() => {
        setRegisterText( 'Get started' );
    }, [registerErrors])

    return (
        <motion.div
        layoutId="auth"
        key="register"
        variants={authAnimation}
        initial="initial"
        animate="visible"
        exit="exit">

            <AnimatePresence exitBeforeEnter>
                {false === user.jwtAuthToken ? (
                    <motion.div
                    variants={authAnimation}
                    initial="initial"
                    animate="visible"
                    exit="exit"
                    layoutId="shareLogin"
                    key="shareLogin">
                        <AuthHeader />

                        <form onSubmit={handleSubmit} autoComplete="off">

                            <div className="errors">
                                {registerErrors && registerErrors.length > 0 ? registerErrors.map((error, key) => (
                                    <div className="alert error" key={key}>{error}</div>
                                )) : ''}
                            </div>

                            <input
                            required
                            type="text"
                            value={username}
                            placeholder="Username*"
                            onChange={e => setUserName(e.target.value)} />

                            <input
                            required
                            type="email"
                            value={email}
                            placeholder="Email address*"
                            onChange={e => setEmail(e.target.value)} />

                            <input
                            required
                            type="password"
                            value={password}
                            placeholder="Choose a password*"
                            onChange={passwordChange}/>

                            <div className={`strength ${colour}`}>
                                <span></span>
                            </div>

                            <p>By continuing, you agree to UoG's <a href="https://www.glos.ac.uk/website-disclaimer/" rel="noopener noreferrer" target="_blank">Terms & Conditions</a> and <a href="https://www.glos.ac.uk/information/knowledge-base/website-privacy-policy/" rel="noopener noreferrer" target="_blank">Privacy Policy</a></p>

                            <button type="submit" className="button login">{registerText}</button>
                        </form>

                        <p className="inline-or">OR</p>

                        <SmileGoogleLogin text="Continue with Google" />
                        <SmileFacebookLogin text="Continue with Facebook" />

                    </motion.div>
                ) : (
                    <motion.div
                    variants={authAnimation}
                    initial="initial"
                    animate="visible"
                    exit="exit"
                    layoutId="shareLogin"
                    key="saveLoad">
                        <SaveOrLoad/>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}

export default Register;
